import { getUserMenu, getUserMenus } from '@/api/manager/menu'
import i18n, { setI18n } from '@/i18n'
import EventHandler from '@/utils/eventHandler'

var menuUtils = {
  setTreeMenu(menuData) {
    var tree = { children: [] }

    menuData.forEach(menuItem => {
      this.resolveTreeMenu(menuItem, tree, tree)
    })

    return tree.children
  },
  resolveTreeMenu(menuItem, targetMenuItem, tree) {
    if ((menuItem.menulevel | 0) === 1) {
      tree.children.push(menuItem)
      return
    }

    if (menuItem['prnt_menu_id'] === targetMenuItem['menu_id']) {
      if (!targetMenuItem.children) targetMenuItem.children = []
      targetMenuItem.children.push(menuItem)
      return
    }
    if (targetMenuItem.children) {
      targetMenuItem.children.forEach(newTargetMenuItem => {
        this.resolveTreeMenu(menuItem, newTargetMenuItem, tree)
      })
    }
  }
}

export default {
  state: {
    menus: [],
    treeMenus: [],
    tabIndex: 0,
    // 선택된 메뉴 정보, 1depth 메뉴가 선택 시, 변경을 위해 사용된다.
    selectedMenu: {
      menu_id: ''
    },
    flag: {
      asideVisiable: true,
      asideUse: true,
      tagViewUse: true,
      headerUse: true,
      footerUse: true,
      myMenuVisible: false,
      navigationDrawer: true,
      bookMarkDrawer: false
    },
    // D type 상단메뉴를 표시할 때 사용한다.
    topbarMenu: {
      showMenuCount: 5,
      startMenuIndex: 0,
      topbarVisible: false
    }
  },
  mutations: {
    SET_MENU: (state, menus) => {
      state.menus = menus
    },
    SET_TREE_MENU: (state, treeMenus) => {
      state.treeMenus = treeMenus
    },
    SET_TAB_INDEX: (state, tabIndex) => {
      state.tabIndex = tabIndex
    },
    SET_CURRENT_MENU: (state, selectedMenu) => {
      state.selectedMenu = selectedMenu
    },
    SET_ASIDE_MENU_USE: (state, flag) => {
      state.flag.asideUse = flag
    },
    SET_TAG_VIEW_USE: (state, flag) => {
      state.flag.tagViewUse = flag
    },
    SET_HEADER_USE: (state, flag) => {
      state.flag.headerUse = flag
    },
    SET_FOOTER_USE: (state, flag) => {
      state.flag.footerUse = flag
    },
    TOGGLE_ASIDE_MENU_VISIABLE: state => {
      state.flag.asideVisiable = !state.flag.asideVisiable
    },
    SET_SHOW_ASIDE_MENU: (state, flag) => {
      state.flag.asideVisiable = !!flag
    },
    SET_SHOW_MENU_COUNT: (state, showMenuCount) => {
      state.topbarMenu.showMenuCount = showMenuCount
    },
    SET_START_MENU_INDEX: (state, startMenuIndex) => {
      state.topbarMenu.startMenuIndex = startMenuIndex
    },
    SET_TOPBAR_MENU_VISIBLE: (state, visible) => {
      state.topbarMenu.topbarVisible = visible
    },
    TOGGLE_MY_MENU_VISIBLE: state => {
      state.flag.myMenuVisible = !state.flag.myMenuVisible
    },
    SET_NAVIGATION_DRAWER: (state, flag) => {
      state.flag.navigationDrawer = flag
    },
    SET_BOOKMARK_DRAWER: (state, flag) => {
      state.flag.bookMarkDrawer = flag
    }
  },
  actions: {
    GetMenus({ commit }) {
      return new Promise((resolve, reject) => {
        // 초기화
        commit('SET_MENU', [])
        commit('SET_TREE_MENU', [])
        getUserMenu()
          .then(response => {
            response.forEach(menu => {
              menu.title = menu.mnu_nm
              menu.prnt_menu_id = menu.prnts_menu_id
              menu.sort = menu.mnu_seq
            })

            commit('SET_MENU', response)
            commit('SET_TREE_MENU', menuUtils.setTreeMenu(response))
            // FIXME: 현대중공업 현재 기준으로 하드 코드된 내역... 차후 수정 되어야 함.
            // 가져온 메뉴 값을 가지고 i18n에 값을 셋팅한다.

            // let ko = {}
            // let en = {}
            // response.forEach(menu => {
            //   ko[menu.menu_id] = menu.title
            //   en[menu.menu_id] = menu.title_eng ? menu.title_eng : menu.menu_id
            // })
            // i18n.mergeLocaleMessage('ko', ko)
            // i18n.mergeLocaleMessage('en', en)
            // 메뉴가 다 불러오면, 이를 사용하는 측에 이벤트를 발송한다.
            EventHandler.emit('loaded-menu')
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    GetUserMenus({ commit }, user_id) {
      return new Promise((resolve, reject) => {
        // 초기화
        commit('SET_MENU', [])
        commit('SET_TREE_MENU', [])
        getUserMenus(user_id)
          .then(response => {
            let menus = response.filter(item => item.href.indexOf('/bill') < 0 && item.href.indexOf('/service') < 0 && item.href.indexOf('/receipt') < 0)
            commit('SET_MENU', menus)
            commit('SET_TREE_MENU', menuUtils.setTreeMenu(menus))
            // FIXME: 현대중공업 현재 기준으로 하드 코드된 내역... 차후 수정 되어야 함.
            // 가져온 메뉴 값을 가지고 i18n에 값을 셋팅한다.
            let ko = {}
            let en = {}
            menus.forEach(menu => {
              ko[menu.menu_id] = menu.title
              en[menu.menu_id] = menu.title_eng ? menu.title_eng : menu.menu_id
            })
            i18n.mergeLocaleMessage('ko', ko)
            i18n.mergeLocaleMessage('en', en)
            EventHandler.emit('loaded-menu')
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    SetTabIndex({ commit }, tabindex) {
      commit('SET_TAB_INDEX', tabindex)
    },
    SetSelectedMenu({ commit }, menu) {
      commit('SET_CURRENT_MENU', menu)
    },
    SetAsideMenuUse({ commit }, flag) {
      if (typeof flag !== 'boolean') return
      commit('SET_ASIDE_MENU_USE', flag)
    },
    SetTagViewUse({ commit }, flag) {
      if (typeof flag !== 'boolean') return
      commit('SET_TAG_VIEW_USE', flag)
    },
    SetHeaderUse({ commit }, flag) {
      if (typeof flag !== 'boolean') return
      commit('SET_HEADER_USE', flag)
    },
    SetFooterUse({ commit }, flag) {
      if (typeof flag !== 'boolean') return
      commit('SET_FOOTER_USE', flag)
    },
    ToggleAsideMenuVisiable({ commit }) {
      commit('TOGGLE_ASIDE_MENU_VISIABLE')
    },
    SetShowAsideMenu({ commit }, flag) {
      commit('SET_SHOW_ASIDE_MENU', flag)
    },
    SetShowMenuCount({ commit }, showMenuCount) {
      commit('SET_SHOW_MENU_COUNT', showMenuCount)
    },
    SetStartMenuIndex({ commit }, startMenuIndex) {
      commit('SET_START_MENU_INDEX', startMenuIndex)
    },
    SetTopbarMenuVisible({ commit }, visible) {
      commit('SET_TOPBAR_MENU_VISIBLE', visible)
    },
    ToggleMyMenuVisible({ commit }) {
      commit('TOGGLE_MY_MENU_VISIBLE')
    },
    SetNavigationDrawer({ commit }, flag) {
      commit('SET_NAVIGATION_DRAWER', flag)
    },
    SetBookmarkDrawer({ commit }, flag) {
      commit('SET_BOOKMARK_DRAWER', flag)
    }
  }
}
